import firebase from "firebase/app";

import { useState } from "react";

import getDistributionChannelsQuery from "astrid-firestore/src/api/distribution/getDistributionChannelsQuery";
import useCollectionData from "astrid-firestore/src/hooks/useCollectionData";

import Table from "../../../tables/components/Table";

import useDistributionArgsDropdownOptions from "../../hooks/useDistributionArgsDropdownOptions";
import useDistributionArgsTableColumns from "../../hooks/useDistributionArgsTableColumns";

import DistributionArgsForm from "../DistributionArgsForm/DistributionArgsForm";

export default function DistributionArgsTable({ publisher }) {
	const [openEdit, setOpenEdit] = useState(false);
	const [distributionChannels] = useCollectionData(getDistributionChannelsQuery(firebase));

	const data =
		Object.entries(publisher?.distribution?.channels || {}).flatMap(([channelId, value]) => {
			const channel = distributionChannels?.find((channel) => channel.id === channelId);

			return Object.entries(value?.actions || {}).map(([actionName, action]) => {
				return {
					channelId: channel?.id,
					channel: channel?.name,
					action: actionName,
					args: action.args,
					conditionalArgs: action.conditionalArgs,
				};
			});
		}) || [];

	const columns = useDistributionArgsTableColumns();

	const getDropdownMenuOptions = useDistributionArgsDropdownOptions({ publisher, setOpenEdit });

	return (
		<>
			<Table data={data} columns={columns} getDropdownMenuOptions={getDropdownMenuOptions} />

			{openEdit && (
				<DistributionArgsForm publisher={publisher} editData={openEdit} onClose={() => setOpenEdit(false)} />
			)}
		</>
	);
}
